export const pageName = Object.freeze({
    SearchPreview: 0,
    AllResults: 1    
});